exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-15528c0d]:root {\n  --main-color-1: #8618EA;\n  --main-color-2: #B94BFF;\n}\n#v_app[data-v-15528c0d] {\n  height: 100%;\n}\n.ele-search[data-v-15528c0d] {\n  margin-left: auto;\n  margin-right: 0;\n  width: 400px;\n  max-width: 400px;\n}\n.img-avatar[data-v-15528c0d] {\n  width: 24px;\n  height: 24px;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n.tag-active[data-v-15528c0d] {\n  width: 90px;\n  display: inline-block;\n  min-width: initial;\n}\n.error-text[data-v-15528c0d] {\n  font-size: 14px;\n  color: #E74C3C;\n}", ""]);

// exports
